import {Col, Row, Select, Tag} from 'antd';
import React, {SyntheticEvent, useEffect, useState} from "react";
import {SelectionMode} from '@models/index';
import resourceFetcherHoc from "@hocs/resourceFetcherHoc";
import {Resource} from "@models/resource";
import {FormattedMessage} from 'react-intl';
import clsx from "clsx";


const Option = Select.Option;


export interface ResourceMultiSelectionReturnValue {
  new_resources: string[];
  deleted_resources: string[];
}

export const resourceMultiSelectionDefaultReturnValue: ResourceMultiSelectionReturnValue = {
  new_resources: [],
  deleted_resources: []
};

type ResourceSelectionProps = {
  mode: SelectionMode,
  onChange: (value: ResourceMultiSelectionReturnValue) => void
  selectedResources: Resource[],
  data: Resource[],
  onScroll: (e: SyntheticEvent) => void,
  handleSearch: (query: string) => void,
  filter?: object,
  onFocus: () => void
}


/**
 * This class handle multi selection of resources
 * Use Select fro ant-design because it has on scroll option
 * In terms of lazy loading of data, selected items should bre rendered separated
 * On Change callback return an object from new and deleted resources
 * @param props
 * @constructor
 */
const ResourceMultiSelection: React.FC<ResourceSelectionProps> = props => {
  const {handleSearch, onScroll, data = [], selectedResources, onChange, onFocus} = props;
  const [selectedItems, setSelectedItems] = useState(selectedResources);
  const [returnValue, setReturnValue] = useState<ResourceMultiSelectionReturnValue>(resourceMultiSelectionDefaultReturnValue);
  
  useEffect(() => {
    setSelectedItems(selectedResources);
  }, [selectedResources]);
  
  useEffect(() => {
    onChange(returnValue);
  }, [returnValue]);
  
  
  /**
   * if the deleted resource is assigned before should add to deleted resource
   * else it is enough to remove it from new resources
   * @param resource_id
   */
  const handleDelete = (resource_id: string): void => {
    const is_selected_before = selectedResources.find(c => c.id == resource_id);
    
    if (is_selected_before) {
      setReturnValue({
        ...returnValue,
        deleted_resources: [...returnValue.deleted_resources, resource_id]
      })
    }
    else {
      setReturnValue({
        ...returnValue,
        new_resources: returnValue.new_resources.filter(id => id != resource_id)
      })
    }
    setSelectedItems(selectedItems.filter(resource => resource.id != resource_id));
  };
  
  /**
   * check if a new added resource is deleted before
   */
  const handleAdd = (resource_id, option) => {
    const isSelectedBefore = selectedItems.find(c => c.id == resource_id) ? true : false;
    if (!isSelectedBefore) {
      setReturnValue({
        deleted_resources: returnValue.deleted_resources.filter(id => id != resource_id),
        new_resources: [...returnValue.new_resources, resource_id]
      });
      setSelectedItems([...selectedItems, option.props.resource]);
    }
  };
  
  return (
    <Row gutter={24} className={`selected-with-add-btn`}>
      <Col span={24} className={`selection-input-wrapper`}>
        <Select
          showSearch
          mode={SelectionMode.MULTIPLE}
          value={[]}
          defaultActiveFirstOption={false}
          showArrow={true}
          filterOption={false}
          onSelect={handleAdd}
          onFocus={onFocus}
          onSearch={handleSearch}
          onPopupScroll={onScroll}
          // placeholder={<FormattedMessage id="app.select_resource" defaultMessage={`Select Resource`}/>}
          notFoundContent={null}
        >
          {data.map((d, index) =>
            <Option className={clsx({
              "selected": selectedItems.find(c => c.id == d.id)
            })} value={d.id} key={index} resource={d}>{d.title}</Option>
          )}
        </Select>
      </Col>
      <Col span={24} className={'selected-items-badge-list'}>
        {selectedItems.map(resource => (
          <Tag key={resource.id} closable={true} onClose={() => handleDelete(resource.id)}>
            {resource.title}
          </Tag>
        ))}
      </Col>
    </Row>
  );
};

export default resourceFetcherHoc(ResourceMultiSelection);


